import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

export const getDescription = ({ step, t }) => {
  const data =
    step?.details && Object.keys(step?.details).length !== 0
      ? step.details
      : step.actionHttpRequest;

  return t('Send %{method}% Request to ‘%{url}%’', {
    method: data.method,
    url: data.url,
    interpolation: { prefix: '%{', suffix: '}%' },
  });
};

export default function HttpRequestCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
